import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import BtnsLessons from './BtnsLessons/BtnsLessons';
import VideoLesson from './VideoLesson/VideoLesson';
import Activity from './Activity/Activity';
import QuizContainer from './QuizContainer/QuizContainer';
import CoevaluationUsersContainer from './CoevaluationUsersContainer/CoevaluationUsersContainer';
import FinishedCourseMessage from './FinishedCourseMessage/FinishedCourseMessage';

import classes from './LessonLeft.module.css';

const LessonLeft = props => {
  const url = window.location.pathname.split('/');
  const [showMessage] = useState(false);
  const { t } = useTranslation(['lesson']);

  const handleChange = (event, newValue) => {
    props.changeView(newValue);
    let section = '';
    if (newValue === 1) {
      if (props.format === 'AUDIO') {
        section = 'aud';
      } else {
        section = 'f';
      }
      // if (url[2] === 'aud' || url[3] === 'aud') {
      //   section = 'aud';
      // } else {
      //   section = 'f';
      // }
    } else if (newValue === 2) {
      section = 'q';
    } else if (newValue === 3) {
      section = 'ac';
    } else {
      section = 'coe';
    }

    if (url[2] === 'a' || url[2] === 'course') {
      history.replaceState(
        null,
        null,
        `/${url[1]}/${url[2]}/${section}/${url[4]}/${url[5]}`
      );
    } else {
      history.replaceState(
        null,
        null,
        `/${url[1]}/${section}/${url[3]}/${url[4]}`
      );
    }
  };

  const returnVideoHandler = () => {
    if (url[2] === 'a' || url[2] === 'course') {
      history.replaceState(
        null,
        null,
        `/${url[1]}/${url[2]}/f/${url[4]}/${url[5]}`
      );
    } else {
      history.replaceState(
        null,
        null,
        `/${url[1]}/${props.format === 'AUDIO' ? 'aud' : 'f'}/${
          url[3]
        }/${url[4]}`
      );
    }
    props.changeView(1);
  };

  useEffect(() => {
    if (url[2] === 'q' || url[3] === 'q') {
      props.changeView(2);
    } else if (url[2] === 'ac' || url[3] === 'ac') {
      props.changeView(3);
    } else if (url[2] === 'coe' || url[3] === 'coe') {
      props.changeView(4);
    } else if (
      url[2] === 'aud' ||
      url[3] === 'aud' ||
      url[2] === 'lesson' ||
      url[3] === 'lesson'
    ) {
      props.changeView(1);
    }
  }, []);

  return (
    <div className={classes.lessonLeftContainer}>
      {!showMessage ? (
        <>
          {props.view === 1 && (
            <BtnsLessons
              lessonData={props.lessonInfo.data}
              idLesson={props.idLesson}
              idCourse={props.idCourse}
              loadLesson={props.loadLesson}
              format={props.format}
            />
          )}
          <Tabs
            value={props.view}
            onChange={handleChange}
            TabIndicatorProps={{ style: { background: '#890f20' } }}
          >
            <Tab
              className={`${classes.tab} ${
                props.view === 1 && classes.itemSelected
              }`}
              value={1}
              label={
                url[2] === 'lesson' || url[3] === 'lesson'
                  ? 'Lección'
                  : props.format === 'AUDIO'
                  ? 'Audio'
                  : t('video')
              }
            />
            <Tab
              className={
                props.lessonInfo.data.idQuiz > 0 &&
                props.lessonInfo.data.isShowQuiz
                  ? `${classes.tab} ${
                      props.view === 2 && classes.itemSelected
                    }`
                  : classes.tabNoShow
              }
              value={2}
              label={t('assessment')}
            />
            <Tab
              className={
                props.lessonInfo.data.hasEvaluacion
                  ? `${classes.tab} ${
                      props.view === 3 && classes.itemSelected
                    }`
                  : classes.tabNoShow
              }
              value={3}
              label={t('activity')}
            />
            <Tab
              className={
                props.lessonInfo.data.hasEvaluacion
                  ? `${classes.tab} ${
                      props.view === 4 && classes.itemSelected
                    }`
                  : classes.tabNoShow
              }
              value={4}
              label={t('peer_evaluation')}
            />
          </Tabs>
          {props.view === 1 &&
            Number.isInteger(props.historyMedia) && (
              <VideoLesson
                idCourse={props.idCourse}
                idLesson={props.idLesson}
                videoData={props.lessonInfo}
                changeVideoStatus={props.changeVideoStatus}
                historyMedia={props.historyMedia}
                transcriptHandler={props.transcriptHandler}
                playerTimeHandler={props.playerTimeHandler}
              />
            )}
          {props.view === 2 && (
            <QuizContainer
              idCourse={props.idCourse}
              idLesson={props.idLesson}
              changeQuizStatus={props.changeQuizStatus}
              returnVideo={returnVideoHandler}
            />
          )}
          {props.view === 3 && (
            <Activity
              returnVideo={returnVideoHandler}
              idCourse={props.idCourse}
              idLesson={props.idLesson}
              changeHomeworkStatus={props.changeHomeworkStatus}
            />
          )}
          {props.view === 4 && (
            <CoevaluationUsersContainer
              idCourse={props.idCourse}
              idLesson={props.idLesson}
              changeCoevaluationStatus={
                props.changeCoevaluationStatus
              }
            />
          )}
        </>
      ) : (
        <FinishedCourseMessage />
      )}
    </div>
  );
};

LessonLeft.propTypes = {
  // eslint-disable-next-line react/require-default-props
  lessonInfo: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  view: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeVideoStatus: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeQuizStatus: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeHomeworkStatus: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeCoevaluationStatus: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  loadLesson: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  transcriptHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  playerTimeHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  historyMedia: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  format: PropTypes.string
};

export default LessonLeft;
